var heroCtaComponent = function($) {

    var $container;

    function initModal(videoID, videoDIV, $modal){
        var options = {
                id: videoID,
                width: 1400,
                loop: false,
                byline : false,
                title: false,
                portrait: false
            };
        var player = new Vimeo.Player(videoDIV, options);

        $modal.on('closing',  function (e) {
            player.pause();
        });
    }

    function init() {
        $container = $('.hero-cta');

        $container.each(function(){
            var $this = $(this);
            var $playButton = $this.find(".hero-cta__video-trigger");
            var modalId = $playButton.data("remodal-target");
            var $modal = $("body").find("[data-remodal-id=" + modalId + "]");
            var $videoDiv = $modal.find(".hero-cta__video");
            var videoID = $modal.data("modalvideo");

            if($playButton.length > 0)
                initModal(videoID, $videoDiv[0], $modal);
        });
    }

    return {
        init: init
    };
}(jQuery);

$(function(){
    heroCtaComponent.init();
});
